import React from 'react'


const ScoringAlignment = () => {
  return (
    <div className='qepscoring_sec'>
         <div className='qep_grad'>
          <h2>Scoring Alignment (Audit-Grade)</h2>
          <p>Each area below includes a scoring scale (0, 3, 5), system automation flags, and required criteria. Green = Fully Met. Yellow = Minimal. Red = Missing.</p>
        </div>   
        <ul className='qep_scoreitem'>
          <li>
            <h4>Mission <span>5/5</span></h4>
            <p>Does your account have multiple users? Add them as individual users so they can have their own login and authentication methods.</p>
          </li>
          <li>
            <h4>Vision <span>5/5</span></h4>
            <p>Should define long-term goals. Entry exists, but lacks connection to participant independence or health outcomes.</p>
          </li>
          <li>
            <h4>Values <span>5/5</span></h4>
            <p>Clearly documented with terms like dignity, equity, transparency. Fully Met.</p>
          </li>
          <li className='view_miss'>
            <div>
            <h4>Stakeholder Input <span className='qep_red'>0/5</span></h4>
            <p>Quarterly survey + family/participant input documented. Automatically compiled from meeting/survey modules.</p>
            </div>
              <button type='button' className='rep_red_btn'>View Missing</button>
          </li>
          <li className='view_miss view_yell'>
            <div>
            <h4>Quality Council  <span className='qep_yellow'>5/5</span></h4>
            <p>Council members, attendance, and decisions recorded. Meeting reminders triggered quarterly.</p>
            </div>
            <button type='button' className='rep_red_btn'>View Missing</button>
          </li>
          <li>
            <h4>Performance Indicators <span>5/5</span></h4>
            <p>Minimum of 3 outcome metrics (satisfaction, service delivery, timeliness) pulled from system reports.</p>
          </li>
          <li className='view_miss'>
            <div>
            <h4>Data Review <span className='qep_red'>0/5</span></h4>
            <p>Performance trends are visualized, and alerts show when indicators fall below target.</p>
            </div>
            <button type='button' className='rep_red_btn'>View Missing</button>
          </li>
          <li>
            <h4>Root Cause Analysis <span> 5/5</span></h4>
            <p>Low scores trigger RCA template with common trends (e.g., missed visits, duplicate tasks).</p>
          </li>
          <li>
            <h4>Goals/Objectives<span> 5/5</span></h4>
            <p>Does your account have multiple users? Add them as individual users so they can have their own login and authentication methods.</p>
          </li>
          <li>
            <h4>Benchmarks <span> 5/5</span></h4>
            <p>Quarterly benchmark targets align with goals. System prompts if timelines are missed.</p>
          </li>
          <li>
            <h4>Action Plans<span> 5/5</span></h4>
            <p>Steps tied to each goal, person responsible assigned, and progress status captured.</p>
          </li>
          <li>
            <h4>Review Cycle<span> 5/5</span></h4>
            <p>Calendar shows 2+ review meetings/year. Sign-off required at each cycle checkpoint.</p>
          </li>
          <li>
            <h4>QEP Evaluation<span> 5/5</span></h4>
            <p>End-of-year evaluation triggers export, goal analysis, and full summary report PDF.</p>
          </li>
         
        </ul>
         
    </div>
  )
}

export default ScoringAlignment;